import { gql } from '@apollo/client';

export const fetchProductsIDForInvoiceGroup = gql`
  query fetchProductsIDForInvoiceGroup(
    $id: ID!
    $fetchEntitlementProductIDs: Boolean
    $searchOptions: ConnectionSearchOptions
  ) {
    invoiceGroup(id: $id) {
      id
      products(fetchEntitlementProductIDs: $fetchEntitlementProductIDs, searchOptions: $searchOptions) {
        totalCount
        pageInfo {
          endCursor
          hasNextPage
        }
        nodes {
          productId
          productName
        }
      }
    }
  }
`;
